module.exports = __webpack_public_path__ + "img/local_files_category.ccce195d.png";